/**
 * Halachic Calendar Engine — Configuration
 */

export const DEFAULT_CONFIG = {
  location: { lat: 31.7683, lng: 35.2137, timezone: 'Asia/Jerusalem' }, // Jerusalem default
  isIsrael: true,
  edah: 'ashkenaz',          // 'ashkenaz' | 'sephardic' | 'mizrahi'
  mgaDegrees: 19.8,          // 19.8 | 16.1
  yomHaatzmautHallel: true,
  yomYerushalayimHallel: false,
};

/**
 * Merge user config with defaults.
 * @param {object} userConfig - partial config
 * @returns {object} full config
 */
export function resolveConfig(userConfig = {}) {
  return {
    ...DEFAULT_CONFIG,
    ...userConfig,
    location: { ...DEFAULT_CONFIG.location, ...(userConfig.location || {}) },
  };
}
